var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "warning-card",
        [
          _c(
            "notice",
            { attrs: { icon: "/static/close.svg", title: _vm.title } },
            [
              _c("div", [
                _vm._v(
                  "\n      Comunicamos através deste que estamos encerrando, por período indefinido, a nossa operação em\n      "
                ),
                _c("b", [
                  _vm._v(_vm._s(_vm._f("formatCities")(_vm.closedCities)))
                ]),
                _vm._v(
                  ". A partir de 18/11/19 não é mais possível contratar novas limpezas.\n      "
                ),
                _c("b", [_vm._v("Mas não se preocupe :),")]),
                _vm._v(
                  " caso você já tenha limpezas agendadas para acontecer além desta data suas limpezas ocorrerão conforme o solicitado.\n      "
                ),
                _c("br"),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v("Esperamos em breve retornar à sua cidade <3")
                ])
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-769d50fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769d50fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Warnings/ClosedCities.vue
// module id = null
// module chunks = 